export default __webpack_public_path__ + "static/portfolio-logo-black-889e952d6520f34c2456b4ac29d9b750.png";